import { getFramework } from '@/framework';
import { LayerType, PluginType, type IExportPlugin } from '@/version-types';
import { behavior } from './behavior';
import { TextLayer } from './domain';
import { ReplaceTextLayerHistory } from './domain/replacer';
import { ShapeTextRenderer } from './edgeless/shape-text-renderer';

export {
    applySnapshotSize,
    applyTextDiff,
    collectFontChars,
    collectFontSubsetRequests,
    createEmptyEditingSnapshot,
    measureLayer,
    requestTextSVGPreview,
    resolveRangeAttrsState,
} from './utils';

export { getShapeTypeConfig, DEFAULT_HIGHLIGHT_THICKNESS } from './config';
export { Events, USE_ENGINE_KEY } from './constants';

export type { ArtTextCharacterConfig } from './domain/art-text';
export type { TextEffectPreset } from './domain/effect';

export type { ShapeTextProps, IEdgelessTextLayer } from './types';

export { TextLayer } from './domain';
export { EdgelessTextLayer } from './edgeless';
export * from './plugins';

/**
 * 文本图层插件
 */
export const textLayerPlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.LAYER,
    name: LayerType.TEXT_LAYER,
    createInstance({ identity }) {
        const shapeTextRenderer = new ShapeTextRenderer(getFramework(identity));
        return [
            { key: 'ShapeTextRenderer', value: shapeTextRenderer },
            { key: 'TextLayer', value: new TextLayer(identity, shapeTextRenderer) },
        ];
    },
    createBehavior() {
        return behavior;
    },
    createHistory({ identity }) {
        return [new ReplaceTextLayerHistory(identity)];
    },
};
